export const SITE = {
  name: "ConstructionWebDesign.uk",
  brand: "ConstructionWebDesign.uk",
  domain: "www.constructionwebdesign.uk",
  url: "https://www.constructionwebdesign.uk",
  tagline: "ConstructionWebDesign.uk is a UK web design agency that only builds websites for construction companies and trades.",
  email: "hello@constructionwebdesign.uk",
  calendly: "https://calendly.com/hello-constructionwebdesign/30min",
  city: "London",
  country: "United Kingdom",
  social: {
    linkedin: "https://www.linkedin.com/company/constructionwebdesign-uk",
  },
};
